export default {"src":"/_next/static/media/close-red-bold.f1100d75.svg","height":12,"width":12};